import { runtimeEnv } from "config/runtimeEnv";
import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "utils/utils";

let env = runtimeEnv("B2B_API_BASE_URL");

export const rateCalculationApi = async (data) => {
  let url = `${env}${API_ENDPOINT.RateCard.calculationApi}`;

  const res = await requestInstance.post(url, data).catch((err) => err.response);
  return setCurrentUser(res);
};
